import { Component, Input } from '@angular/core';
import { environment } from '@environments/environment';
import { IntlService } from '@progress/kendo-angular-intl';
import { BaseCardComponent } from "./base-card.component";
import { Router } from '@angular/router';


@Component({
  selector: 'vehicle-history-card',
  styleUrls: ['./styles/styles-card.css'],
  styles: [`
    .card {
      height: 90px;
    }
    .card-details {
      width: 75%;
    }
  `],
  template: `
    <!--{{vehicle | json}}-->
    <div class="card" [class.border-top]="borderTop" (click)="selectItem($event)">
      <kendo-avatar [imageSrc]="(vehicle.vehicle_type_image != '') ? vehicle.vehicle_type_image: defaultImage" shape="circle" style="padding: 4px; background-color: #{{ vehicle.vehicle_status_color }}"></kendo-avatar>
      <div class="card-details">
        <div class="card-title">
          {{ intl.formatNumber(vehicle.cost_paid, "c2") }} <span class="right">{{ vehicle.sku_exp }} / {{ vehicle.sku_inv }}</span>
        </div>
        <div class="card-subtitle">
          {{ vehicle.marck }}, {{ vehicle.color }} - {{ vehicle.plaque }}
        </div>
        <div class="card-subtitle no-wrap">
          {{ vehicle.place }}
        </div>
        <div class="card-subtitle no-wrap">
          {{ vehicle.deposit_name }}, {{ vehicle.authority_abbreviation }} - {{ vehicle.authority_name }}
        </div>
        <div class="card-subtitle no-wrap" *ngIf="vehicle.id_vehicle_status == 3">
          {{ vehicle.payment_type_name }} - {{ vehicle.person_name }} <span class="right">Duración: {{ vehicle.days }} días</span>
        </div>
      </div>
      <div class="card-actions" *ngIf="action">                
        <span class="k-icon k-icon-md k-i-arrow-chevron-right" style="color: #{{ vehicle.vehicle_status_color }}"></span>
      </div>
    </div>
  `,    
})
export class VehicleHistoryCardComponent extends BaseCardComponent {

  @Input() vehicle!: any;

  @Input() action: boolean = true;
  
  @Input() defaultImage: string = environment.assets.DEFAULT_VEHICLE;

  @Input() returnUrl: string;


  constructor(public intl: IntlService, public router: Router) { 

    super(intl, router)

  }  
  
  public selectItem(event: any) {
    
    this.router.navigate(['/vehicle_actions/' + this.vehicle.id], {state: {returnUrl: this.returnUrl}});

  }

}